// extracted by mini-css-extract-plugin
module.exports = {"InviteeList":"InviteeList_InviteeList__3b6RB"};